// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__cILpG","loader1":"style_loader1__RhJmg","loader2":"style_loader2__azN+C","loader3":"style_loader3__vxDFD"};